import MuiLoadingButton from '@mui/lab/LoadingButton';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Logo = () => {
  return <img src="/images/logo.svg" alt="Logo" />;
};

const redirectRoutes = ['/index', '/index.html'];

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // FIXME - isso tem que estar no nginx
  const hasRedirect = redirectRoutes.some((route) => location.pathname.indexOf(route) != -1);
  if (hasRedirect) {
    window.location.href = '/';
    return null;
  }

  return (
    <Container>
      <Header>
        <Logo />
      </Header>
      <Main>
        <Card>
          <LeftContent>
            <Character src="/images/model_htk.png" alt="404 Logo" />
          </LeftContent>
          <Content>
            <TextWrapper>
              <Title>Ops!</Title>
              <SubTitle>Não conseguimos encontrar sua página</SubTitle>
              <Description>A página que você procura pode estar em manutenção ou não existe</Description>

              <CustomButton onClick={() => navigate('/')} style={{ marginTop: 8 }}>
                Voltar para home
              </CustomButton>
            </TextWrapper>
          </Content>
        </Card>
      </Main>
      <Footer>
        <FooterLogoWrapper>
          <Logo />
          <p style={{ fontSize: '16px', color: '#fff' }}>A mudança que sua empresa precisa</p>
        </FooterLogoWrapper>
        <FooterServiceWrapper>
          <p style={{ fontSize: '16px', color: '#fff', fontWeight: 'bold' }}>Atendimento</p>
          <p style={{ fontSize: '16px', color: '#fff' }}>De segunda à sexta: 09h às 18h.</p>
          <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#fff' }}>(21) 4040-4840</p>
        </FooterServiceWrapper>
      </Footer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  width: 100%;
  background-color: var(--primary-color);
  padding: 1.25rem 3rem;
`;

export const Main = styled.div`
  width: 100%;
  height: calc(100vh - 85px - 139px);

  @media screen and (max-width: 768px) {
    height: calc(100vh - 85px - 232px);
  }
`;

export const Footer = styled.div`
  width: 100%;
  padding: 2rem;
  background-color: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

const CustomButton = styled(MuiLoadingButton)`
  background-color: var(--primary-color);
  color: #fff;
  &:hover {
    background-color: rgba(31, 158, 204, 0.7);
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Title = styled.h1`
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 60px;
  line-height: 73.14px;
`;

const SubTitle = styled.h1`
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 29px;
  max-width: 330px;
  line-height: 38px;
`;

const Description = styled.p`
  font-family: 'PT Sans';
  font-size: 18px;
  max-width: 330px;
  margin-top: 8px;
  line-height: 23.29px;
`;

const Card = styled.div`
  width: 100%;
  min-height: 100%;
  height: 100%;

  display: flex;
  align-items: center;
`;

const Character = styled.img`
  height: 90%;
  object-fit: contain;

  position: absolute;
  bottom: 0;
  right: 20px;

  @media screen and (max-width: 1023px) {
    display: none;
  }
`;

const LeftContent = styled.div`
  position: relative;

  width: 100%;
  height: 100%;
  flex: 1;

  @media screen and (max-width: 1023px) {
    display: none;
  }
`;

const Content = styled.div`
  width: 100%;
  flex: 1;

  display: flex;
  justify-content: flex-start;

  @media screen and (max-width: 1023px) {
    max-width: 100%;
    justify-content: center;
  }
`;

const FooterLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const FooterServiceWrapper = styled.div`
  text-align: end;
  display: flex;
  flex-direction: column;
  gap: 6px;

  @media screen and (max-width: 768px) {
    text-align: center;
  }
`;

export default NotFound;
